import { render, staticRenderFns } from "./TableExtractTransaction.vue?vue&type=template&id=04712ba5"
import script from "./TableExtractTransaction.vue?vue&type=script&lang=js"
export * from "./TableExtractTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports